import React from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom";
const { Header } = Layout;

const AntdHeader = () => {
  return (
    <Header>
      {/* <div className="header-col header-brand">
        <Link to="/dashboard">
          <h5>Mitran Pack DashBoard</h5>
        </Link>
      </div> */}
    </Header>
  );
};
export default AntdHeader;
